import { useMemo } from 'react';
import { caseQueryKeys } from '@/queries/case';
import { WsFallbackConfig } from '@/ws/fallback';
import { wsFallbackConfig } from './ws-fallback.config';

export const useWsFallbackConfig = (hasCaseBoardPermission: boolean): WsFallbackConfig => {
  return useMemo(() => {
    if (!hasCaseBoardPermission) return wsFallbackConfig;

    return {
      ...wsFallbackConfig,
      alwaysOnQueries: [...(wsFallbackConfig.alwaysOnQueries ?? []), caseQueryKeys.getInfiniteList()],
    };
  }, [hasCaseBoardPermission]);
};
